import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { ModelsLayoutProps } from "./types";


const ModelsLayout: FC<ModelsLayoutProps> = ({ children, className }) => {
  return (
    <>
      <TopNav title="Models" />
      <ContentLayout className={className}>{children}</ContentLayout>
    </>
  );
};

export default ModelsLayout;
